import { render, staticRenderFns } from "./BrandTileCmp.vue?vue&type=template&id=475250db&scoped=true&"
import script from "./BrandTileCmp.vue?vue&type=script&lang=js&"
export * from "./BrandTileCmp.vue?vue&type=script&lang=js&"
import style0 from "./BrandTileCmp.vue?vue&type=style&index=0&id=475250db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475250db",
  null
  
)

export default component.exports